module.exports = __webpack_public_path__ + "static/img/vice3.25cacd7d.png";